// extracted by mini-css-extract-plugin
module.exports = {"logo":"index-module_logo_DEulf","title":"index-module_title_m3_Dw"};